"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.monitoring")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.monitoring", {
            url:
                "/monitoramento/:source/:date/:scenario?filter&accountPlanType",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-monitoring" */ "./monitoring.entry"
                ).then(() =>
                    Promise.all([
                        $ocLazyLoad.inject("nucont.accounting.company.monitoring"),
                        $ocLazyLoad.inject("nucont.accounting.company.showtime")
                    ])
                );
            },
            params: {
                date: { value: null, dynamic: true },
                openShowtime: { value: null, dynamic: true },
                scenario: { value: null, dynamic: true },
                source: { value: null, dynamic: true },
                accountPlanType: { value: null, dynamic: true }
            },
            views: {
                "admin@nucont.accounting": {
                    component: "monitoringCompanyComponent",
                    bindings: { companyData: "CompanyData" }
                }
            }
        })
        .state("nucont.accounting.company.monitoring.audit", {
            url: "/auditoria",
            params: {
                from: { value: "audit", dynamic: true }
            },
            views: {
                "tableContent@nucont.accounting.company.monitoring": {
                    component: "monitoringCompanyAuditComponent",
                    bindings: { companyData: "CompanyData" }
                }
            }
        })
        .state("nucont.accounting.company.monitoring.audit.showtime", {
            url: "/showtime"
        })
        .state(
            "nucont.accounting.company.monitoring.audit.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.company.monitoring.audit": {
                        component: "indicatorDescriptionComponent"
                    }
                }
            }
        )
        .state("nucont.accounting.company.monitoring.audit.showtime.comments", {
            url: "/comentarios",
            views: {
                "subModule@nucont.accounting.company.monitoring.audit": {
                    component: "indicatorCommentsComponent",
                    bindings: { companyData: "CompanyData" }
                }
            }
        })
        .state("nucont.accounting.company.monitoring.audit.showtime.insights", {
            url: "/insights",
            views: {
                "subModule@nucont.accounting.company.monitoring.audit": {
                    component: "indicatorInsightsComponent"
                }
            }
        })
        .state("nucont.accounting.company.monitoring.health", {
            url: "/objetivos",
            params: {
                from: { value: "health", dynamic: true }
            },
            views: {
                "tableContent@nucont.accounting.company.monitoring": {
                    component: "goalsCompanyComponent",
                    bindings: {
                        companyData: "CompanyData"
                    }
                }
            }
        })
        .state("nucont.accounting.company.monitoring.health.showtime", {
            url: "/showtime"
        })
        .state(
            "nucont.accounting.company.monitoring.health.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.company.monitoring.health": {
                        component: "indicatorDescriptionComponent"
                    }
                }
            }
        )
        .state(
            "nucont.accounting.company.monitoring.health.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.company.monitoring.health": {
                        component: "indicatorCommentsComponent"
                    }
                }
            }
        )
        .state(
            "nucont.accounting.company.monitoring.health.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.company.monitoring.health": {
                        component: "indicatorInsightsComponent"
                    }
                }
            }
        );
}
